module.exports = __webpack_public_path__ + "static/media/italy-final1.fc805625.png";